'use client';

import { useCallback } from 'react';

import type { CookieType } from '@personly/libs-types';
import { TextSelect } from '@personly/libs-widgets';

import { useConsents } from '@/providers/consents';

interface Props {
  cookieTypes: CookieType[];
}

const CookieTypeSelect = ({ cookieTypes }: Props) => {
  const { selectedCookieType, setSelectedCookieType } = useConsents();

  const onClick = useCallback(
    (cookieType: CookieType) => setSelectedCookieType(cookieType),
    [setSelectedCookieType]
  );

  return cookieTypes.map((cookieType) => (
    <div key={cookieType.handle}>
      {cookieType.handle === selectedCookieType.handle ? (
        <TextSelect>{cookieType.title}</TextSelect>
      ) : (
        <div className="cursor-pointer" onClick={() => onClick(cookieType)}>
          {cookieType.title}
        </div>
      )}
    </div>
  ));
};

export default CookieTypeSelect;
